import * as React from 'react';
import { UitkEmptyState } from 'uitk-react-empty-state';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkIconSize } from 'uitk-react-icons';
import { IntersectionTracker } from '@shared-ui/clickstream-analytics-context';
import { IconMark } from './icon-mark';
export var ActivityEmptyStateCard = function (_a) {
  var data = _a.data;
  var heading = data.heading,
    body = data.body,
    icon = data.icon,
    analytics = data.analytics;
  var emptyStateComponent = React.createElement(UitkEmptyState, null, React.createElement(IconMark, {
    icon: icon,
    defaultIconSize: UitkIconSize.LARGE
  }), heading && React.createElement(UitkHeading, {
    tag: "h3",
    size: 5
  }, heading), React.createElement(UitkText, {
    size: 300,
    theme: "default"
  }, body));
  return React.createElement(React.Fragment, null, React.createElement("div", {
    "data-testid": "empty-state"
  }, analytics ? React.createElement(IntersectionTracker, {
    referrerId: analytics.referrerId,
    linkName: analytics.linkName,
    trackOnce: true,
    intersectionOptions: {
      threshold: 1.0
    }
  }, emptyStateComponent) : React.createElement(React.Fragment, null, emptyStateComponent)));
};